import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Click on the button below to review and confirm your payment information.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'We are working with Stripe to handle payments. Stripe is the most secure payment platform used by the biggest companies worldwide.',
      form: {
        terms_acceptance: {
          label:
            'By proceeding, you agree to our <FoodAmigosTerms>Services Agreement</FoodAmigosTerms> and the <StripeTerms>Stripe Connected Account Agreement.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe has marked some customer info as missing or invalid. Please fix following errors but clicking on "Open stripe profile" button:',
        errors: 'Errors',
        awaiting_verification: 'Your Stripe account is being verified',
        awaiting_verification_description:
          'We are waiting for Stripe to finish verifying your business. You can review your profile in the meantime.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'We are working with Adyen to handle payments. Adyen is one of the most secure payment platform used by the biggest companies worldwide.',
    },
  },
  labels: {
    verified: 'Your {{paymentGateway}} account is verified',
    verified_description:
      'Verification is complete for {{paymentGateway}}. You can still manage your profile if needed.',
  },
  buttons: {
    proceed: 'Confirm my payment info',
    copy_link: 'Copy link',
  },
  toasts: {
    something_went_wrong: 'Something went wrong, please contact technical support',
  },
};
